<template>
  <div class="video-type-selector">
    <div class="video-type-choice-group">
      <label :class="{ selected: !localValue }">
        <input type="radio" v-model="localValue" :value="false" />
        <span class="custom-radio"></span>
        <span class="choice-label"> {{first_text}}</span>
      </label>
      <label :class="{ selected: localValue }">
        <input type="radio" v-model="localValue" :value="true" />
        <span class="custom-radio"></span>
        <span class="choice-label"> {{second_text}}</span>
      </label>
    </div>
    <small v-if="description" class="video-type-desc">{{ description }}</small>
  </div>
</template>

<script>
export default {
  name: "VideoTypeSelector",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    description: {
      type: String,
      default: ""
    },
    first_text: {
      type: String,
      required:true
    },
    second_text: {
      type: String,
      required: true
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  }
};
</script>

<style scoped>
.video-type-selector {
  margin: 1.2rem 0 0.5rem 0;
}

.video-type-choice-group {
  display: flex;
  gap: 16px;
  margin-bottom: 0.5rem;
}

.video-type-choice-group label {
  position: relative;
  display: flex;
  align-items: center;
  padding: 7px 22px 7px 14px;
  border-radius: 8px;
  border: 1.5px solid #23ade5;
  background: #fff;
  font-size: 15px;
  font-weight: 500;
  color: #222;
  cursor: pointer;
  transition: box-shadow 0.15s, background 0.15s, color 0.15s, border 0.15s;
  box-shadow: none;
  user-select: none;
  min-width: 100px;
  min-height: 32px;
  letter-spacing: 0.1px;
}

.video-type-choice-group label.selected {
  background: #23ade5;
  color: #fff;
  border: 1.5px solid #23ade5;
  box-shadow: 0 2px 8px rgba(35,173,229,0.10);
}

.video-type-choice-group label.selected .choice-label {
  color: #fff;
}

.video-type-choice-group input[type='radio'] {
  display: none;
}

.custom-radio {
  width: 20px;
  height: 20px;
  border: 2px solid #23ade5;
  border-radius: 50%;
  margin-right: 10px;
  background: #fff;
  position: relative;
  display: inline-block;
  transition: border-color 0.15s, background 0.15s;
}

.video-type-choice-group label.selected .custom-radio {
  border-color: #fff;
  background: #23ade5;
}

.video-type-choice-group input[type='radio']:checked + .custom-radio::after {
  content: '';
  display: block;
  width: 9px;
  height: 9px;
  background: #fff;
  border-radius: 50%;
  position: absolute;
  top: 3.5px;
  left: 3.5px;
}

.choice-label {
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.1px;
  color: #222;
}

.video-type-desc {
  color: #888;
  font-size: 13px;
  margin-bottom: 1rem;
  display: block;
}
</style> 